import TwoFactorCard from './TwoFactorCard';

export default TwoFactorCard;
